<!--
 * @Author: WGL
 * @Date: 2023-06-21 09:23:33
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-12-08 14:50:42
 * @Description: 
-->
<template>
  <el-popover
    :persistent="false"
    placement="bottom"
    trigger="click"
    :width="800"
  >
    <template #reference>
      <span class="c0 cp">查看</span>
    </template>
    <div v-html="html"></div>
  </el-popover>
</template>

<script>
  // BaseRichText 富文本组件
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'BaseRichText',
    components: {},
    props: {
      html: { type: String, default: '' },
    },
    setup(props) {},
  })
</script>

<style lang="scss" scoped></style>
